var LongObject = (function () {

  function deleteObjects(ids) {
    return $.ajax({
        url: Url.action('api/longObjects'),
        type: 'DELETE',
        data: { ids: ids }
      })
      .done(() => _refreshTable(true, ids));
  };

  function _show(id) {
    const modal = ModalConductor.activate(LongObjectViewModal, id,
        (longObjectId) => {
          deleteObjects([longObjectId]).done(() => {
            modal.close();
          });
        },
        (longObjectId) => {
          _showOnMap([longObjectId]);
        })
      .on('closed',
        (modalResult) => {
          _refreshTable();
          $('video').trigger('pause');
        });
  };

  function _add() {
    ModalConductor.activate(LongObjectEditModal)
     .on('closed', (modalResult) => {
       if (modalResult.ok) {
         _refreshTable();
       }
     });
  };

  function _delete(ids) {
    if (ids.length > 0 && confirm('Вы действительно хотите удалить {0} записей?'.format(ids.length))) {
      deleteObjects(ids);
    }
  };

  function _showOnMap(ids) {
    if (ids.length > 0) {
      location.href = Url.map(ObjectTypes.LongObject, ids);
    }
  };

    function _refreshTable(resetChecked, idsForDeselect) {
        var table = $('#LongObjectListItemViewModelTable').DataTable();
        refreshTable(table, resetChecked, false, idsForDeselect);
    };

  return {
    show: _show,
    add: _add,
    del: _delete,
    showOnMap: _showOnMap
  };
}());
